import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import Navigation from "./Components/navigation";
import { ToastContainer } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import { requestForToken } from "./Services/requestPermission";
import { handleFCMNotification } from "./Components/notificatinhandler/notificationHandler";

function App() {
  const [payload, setPayload] = useState<any>(null);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [currentNotification, setCurrentNotification] = useState<any>(null);

  React.useEffect(() => {
    requestForToken(undefined);
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("FCM payload received:", payload?.data);

      const data = payload?.data ?? {};
      handleFCMNotification({ data });
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="App">
      <Navigation />
      <ToastContainer />
    </div>
  );
}

export default App;
